module.exports = __webpack_public_path__ + "static/how-to-image-4acb6e0369bc43a4f4f53273acc2214f.jpg";